import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectFilters } from '../../Filter/selectors';
import type Filter from '../../Filter';
import type Document from '../Document';
import { FetchDocumentsResult } from './types';

export function buildDocumentsQueryKey(filters: Filter, segmentId: string) {
  return [
    'documents',
    segmentId,
    filters.page,
    filters.size,
    filters.createdFrom,
    filters.createdTo,
    filters.contractNumbers?.length
      ? JSON.stringify(filters.contractNumbers)
      : null,
    filters.products?.length ? JSON.stringify(filters.products) : null,
    filters.categories?.length ? JSON.stringify(filters.categories) : null,
    filters.sortBy,
    filters.sortDirection,
  ];
}

export function useMarkDocumentAsRead(segmentId: string) {
  const queryClient = useQueryClient();
  const activeFilters = useSelector(selectFilters);

  return useCallback(
    (id: Document.Id) => {
      const queryKey = buildDocumentsQueryKey(activeFilters, segmentId);
      queryClient.setQueryData<FetchDocumentsResult>(queryKey, (oldData) => {
        if (!oldData) {
          return undefined;
        }
        return {
          ...oldData,
          documents: oldData.documents.map((document) =>
            document.id === id ? { ...document, isRead: true } : document
          ),
        };
      });
    },
    [queryClient, activeFilters, segmentId]
  );
}
